﻿import React from 'react';
import { str_isEmpty } from '@Util/Utils';
import { Popup_Header_Props } from '@Util/Types';

import Close_Button from '@Elements/Popup/Close_Button';

const Header: React.FC<Popup_Header_Props> = React.memo((props) => {
    return (
        <header
            className="Popup_Header"
            onMouseDown={props.handle_mouse_down}
        >
            {!str_isEmpty(props.title) && (
                <h3 className="Headline3">{props.title}</h3>
            )}
            {!props.disable_close_action && (
                <Close_Button
                    set_open={props.set_open}
                    on_close_action={props.on_close_action}
                />
            )}
        </header>
    );
});

export default Header;